export class User {
    id: number;
    username: string;
    token?: string;
    onboardComplete: boolean;
}

export class QuestionAnswer {
    questionId: number;
    assessmentId: number;
    questionText: string;
    placeholder: string;
    answer: string;
    reflection: string;
    answerId: number;
}

export class TopicAnswers {
    topicId: number;
    answers: QuestionAnswer[];
}

export class UserSearchFilter {
    term: string;
    sectorIds: number[];
    sectors = [];
    cityId: string;
    city: string;
}